import { memo, useState } from "react";
import Input from "../../components/input/input";
import Button from "../../components/button/button";
import styles from '../loginSignup.module.css';
import { resetPasswordEmail } from "../../services/api";

export default memo(function ResetComponent({ signUpFunc, setinfoPopup }) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('')
    const sendResetEmail = async () => {
        let sentEmail = await resetPasswordEmail(email)
        if (sentEmail.ok) {
            setinfoPopup({ show: true, message: "A link to reset your password has been sent to your email." });
        } else setError(sentEmail.data?.message || "Unable to send reset email. Please try again.")
    };
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '10px', marginTop: '40px' }}>
                <h2 style={{ fontSize: '28px' }}>Reset Your Password</h2>
                <p>Enter your email and we’ll send you a link to reset your password</p>
            </div>
            <div className={styles.inputcontainer} style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '10px' }}>
                <Input
                    id="email"
                    label="Email"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        setError('')
                    }}
                    style={(email?.length > 0 && (!email || !email.includes('@'))) ? { border: '1px solid red' } : null}
                    errText={email?.length > 0 && !email.includes('@') ? 'Please enter a valid email address' : null}
                />
                {error && <p style={{ 'color': "red" }}>{error}</p>}
                <Button onClick={sendResetEmail} children={'Send link to email'} style={{ 'marginTop': '0' }} disabled={error || !email || !email.includes('@')} />
            </div>
            <p style={{ marginTop: '10px', cursor: 'pointer', position: 'absolute', bottom: "20px" }} >Don't have an account? <span onClick={signUpFunc} style={{ textDecoration: "underline" }}>Sign up</span></p>
        </>
    )
})
